import { type SearchEntry } from '@ctn/ui/types/ctn-filter-bar';
import { yupResolver } from '@hookform/resolvers/yup';
import { type Resolver } from 'react-hook-form';
import * as yup from 'yup';

import { PAGE_SIZE } from '@/constants/table.constants';
import { SOLICITUD_ESTADOS } from '@/constants/tramite.constants';

export const PAYLOAD_PAGINATION = {
	start: 0,
	limit: PAGE_SIZE.OPERACIONES,
};

export const payloadDefault = (idTipoTramite: number) => ({
	...PAYLOAD_PAGINATION,
	listaIdsEstadoSolicitud: [SOLICITUD_ESTADOS.BORRADOR],
	listaIdsTipoTramite: [idTipoTramite],
});

export type FilterFormData = {
	tipoBusqueda: string;
	busqueda: string;
	tipoTramite: string[];
	search?: SearchEntry[];
};
    
export const getSchema = (): Resolver<FilterFormData> => {
	const schema = yup.object().shape({
		tipoBusqueda: yup.string(),
		busqueda: yup.string(),
		tipoTramite: yup.array(),
	});
	return yupResolver(schema) as Resolver<FilterFormData>;
};
    
export const defaultValues = (idTipoTramite: number) => ({
	tipoBusqueda: 'numeroTramiteExterno',
	busqueda: '',
	tipoTramite: [String(idTipoTramite)],
	search: [],
});